export function isDateInRange(
  popupStartDate: Date,
  popupEndDate: Date
): boolean {
  const currentDate = new Date();

  const currentDateOnly = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );
  const startDateOnly = new Date(
    popupStartDate.getFullYear(),
    popupStartDate.getMonth(),
    popupStartDate.getDate()
  );
  const endDateOnly = new Date(
    popupEndDate.getFullYear(),
    popupEndDate.getMonth(),
    popupEndDate.getDate()
  );

  return currentDateOnly >= startDateOnly && currentDateOnly <= endDateOnly;
}
